
import PIXI from '../GameEngine/pixi.js';
import Button from './ButtonSolid.js'
import ButtonSmall from './ButtonSmall.js'
export default class GameOver extends PIXI.Container {
    constructor(message, scorePlayer1, scorePlayer2, ...arg) {
        super(...arg);
        this.message = message || 'You win!';
        this.player1Name = "You";
        this.player2Name = "Computer";
        this.readyPlayer1 = false;
        this.readyPlayer2 = false;
        this.scorePlayer1 = scorePlayer1 || 0;
        this.scorePlayer2 = scorePlayer2 || 0;
        this.allowRematch = true;
        this.onClose = function () { };
        this.onRematch = function () { };
        this.onDetails = function () { };

        // this.interactive = true;
        // this.on('pointerdown', this.close_onClick.bind(this));


        //background
        // var popupBackground = new PIXI.Graphics();
        // popupBackground.beginFill(0x000000);
        // popupBackground.drawRect(-500, -500, 1000, 1000);
        // popupBackground.alpha = 0.1;
        // this.addChild(popupBackground);

        this.container = new PIXI.Container();
        this.addChild(this.container);




        var styleTitle = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 40 * 2,
            fill: '#FFFFFF',
            wordWrap: true,
            wordWrapWidth: 800,
            align: 'center'
        });
        var styleLarge = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 32 * 2,
            fill: '#FFFFFF'
        });
        var styleNormal = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 24 * 2,
            fill: '#FFFFFF'
        });
        let styleSmall = new PIXI.TextStyle({
            fontFamily: "Segoe UI,Frutiger,Frutiger Linotype,Dejavu Sans,Helvetica Neue, Arial, sans-serif",
            fontSize: 12 * 2,
            fill: '#FFFFFF'
        });



        //background
        var graphics = new PIXI.Graphics();
        graphics.beginFill(0x333333);
        graphics.lineStyle(0, 0xFFFFFF, 1);
        // graphics.drawRect(0, 0, 500, 500);
        graphics.drawRoundedRect(0, 0, 400, 140, 10);
        // graphics.alpha = 0.5;
        this.container.addChild(graphics);



        //textTitle
        this.textTitle = new PIXI.Text("You Win!", styleTitle);
        this.textTitle.x = 200;
        this.textTitle.y = 10;
        this.textTitle.anchor.set(0.5, 0);
        this.textTitle.scale.set(0.5);
        this.container.addChild(this.textTitle);

        //Next Round  button
        this.btnNext = new Button("Details", 0xC03500, 185);
        this.btnNext.x = 10;
        this.btnNext.y = 70;
        this.btnNext.interactive = true;
        this.btnNext.on('pointerdown', this.btnDetails_onClick.bind(this));
        this.container.addChild(this.btnNext);

        //rematch indicator ready
        this.btnHighlightReady = new PIXI.Graphics();
        this.btnHighlightReady.lineStyle(2, 0xFFFF00, 3);
        this.btnHighlightReady.drawRoundedRect(205, 70, 185, 60, 10);
        this.container.addChild(this.btnHighlightReady);

        //Next Round  button
        this.btnRematch = new Button("Rematch", 0x479ACE, 185);
        this.btnRematch.x = 205;
        this.btnRematch.y = 70;
        this.btnRematch.interactive = true;
        this.btnRematch.on('pointerdown', this.btnRematch_onClick.bind(this));
        this.container.addChild(this.btnRematch);

        // //Next Round  button
        // this.btnNext = new ButtonSmall("Details",  0x444444, 100);
        // this.btnNext.x = 150;
        // this.btnNext.y = 70+60+5;
        // this.btnNext.interactive = true;
        // this.btnNext.on('pointerdown', this.btnDetails_onClick.bind(this));
        // this.container.addChild(this.btnNext);
    }
    update() {
        let isDirty = false;
        if (this.textTitle.text !== this.message) isDirty = true;
        if (this.btnHighlightReady.visible !== this.readyPlayer1 || this.readyPlayer2) isDirty = true;

        if (this.allowRematch) {
            this.btnRematch.interactive = true;
            this.btnRematch.alpha = 1;
        } else {
            this.btnRematch.interactive = false;
            this.btnRematch.alpha = 0.3;
        }
        //this.btnRematch.visible = this.allowRematch;
        this.textTitle.text = this.message;
        this.btnHighlightReady.visible = this.readyPlayer1 || this.readyPlayer2;
    }

    btnDetails_onClick(event) {
        //this.visible = false;
        this.parent.isDirty = true;
        event.stopPropagation();
        if (this.onDetails) {
            this.onDetails();
        }
    }
    btnRematch_onClick(event) {
        //this.visible = false;
        this.parent.isDirty = true;
        event.stopPropagation();
        if (this.onRematch) {
            this.onRematch();
        }
    }
    btnNext_onClick(event) {
        this.visible = false;
        this.parent.isDirty = true;
        // this.parent.isDirty = true;
        // this.parent.removeChild(this);
        event.stopPropagation();
        if (this.onClose) {
            this.onClose();
        }
    }
    close_onClick() {
        if (this.onClose) {
            this.onClose();
        }
        this.visible = false;
        this.parent.isDirty = true;
        //  this.parent.isDirty = true;
        //   this.parent.removeChild(this);
    }
}